<template>
    <div>
        <div class="card shadow">
            <div class="card-header bg-transparent">
                <div>
                    <h3 class="mb-0">
                        {{ $tc('message.ultrasounds', 1) }}
                    </h3>
                </div>
            </div>

            <div class="card-body">
                <div class="card">
                    <b-container>
                        <div class="list-group list-group-flush">
                            <b-row>
                                <b-col col sm="12">
                                    <div class="list-group-item">
                                        {{ $t('message.amenorrheaWeek') }}:

                                        <span class="font-weight-bold">
                                {{ mUltrasound.semaine_amenorrhee }}
                            </span>
                                    </div>
                                </b-col>
                                <b-col col sm="12">
                                    <div class="list-group-item">
                                        {{ $tc('message.types', 1) }}:

                                        <span class="font-weight-bold">
                                {{ mUltrasound.type }}
                            </span>
                                    </div>
                                </b-col>
                            </b-row>
                            <b-row>
                                <b-col col sm="12">
                                    <div class="list-group-item">
                                        {{ $t('message.ddr') }}:

                                        <span class="font-weight-bold">
                                {{ formattedDate(mUltrasound.ddr) }}
                            </span>
                                    </div>

                                </b-col>

                                <b-col col sm="12">

                                    <div class="list-group-item">
                                        {{ $t('message.dpa') }}:

                                        <span class="font-weight-bold">
                                {{ formattedDate(mUltrasound.dpa) }}
                            </span>
                                    </div>

                                </b-col>

                                <b-col col sm="12">

                                    <div class="list-group-item">
                                        {{ $t('message.biometric') }}:

                                        <span class="font-weight-bold">
                                {{ mUltrasound.biometrie }}
                            </span>
                                    </div>

                                </b-col>

                                <b-col col sm="12">

                                    <div class="list-group-item">
                                        {{ $t('message.annex') }}:

                                        <span class="font-weight-bold">
                                {{ mUltrasound.annexe }}
                            </span>
                                    </div>

                                </b-col>

                                <b-col col sm="12">

                                    <div class="list-group-item">
                                        {{ $t('message.description') }}:

                                        <span class="font-weight-bold">
                                {{ mUltrasound.description }}
                            </span>
                                    </div>

                                </b-col>

                            </b-row>
                        </div>
                    </b-container>

                    <div class="card-footer text-right">
                        <b-container>
                            <b-row class="justify-content-sm-center" v-if="mUltrasound.isAuthor || hasAdminRole">
                                <b-button variant="primary" @click="updateUltrasound">
                                    {{ $t('message.edit') }}
                                </b-button>

                                <b-button v-b-modal.delete-modal variant="danger">
                                    {{ $t('message.delete') }}
                                </b-button>
                            </b-row>
                        </b-container>
                    </div>

                    <b-modal
                            id="delete-modal"
                            size="sm"
                            header-bg-variant="danger"
                            header-text-variant="light"
                            :title="$t('message.delete') + ' ' + $tc('message.ultrasounds', 1)"
                            hide-footer
                    >
                        <div class="d-block text-center">
                            <h3>{{ $t('message.delete') }} {{ mUltrasound.type }}?</h3>
                        </div>

                        <div class="d-block float-right">
                            <b-button variant="danger" @click="deleteUltrasound">
                                {{ $t('message.delete') }}
                            </b-button>

                            <b-button variant="secondary" @click="$bvModal.hide('delete-modal')">
                                {{ $t('message.cancel') }}
                            </b-button>
                        </div>
                    </b-modal>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';
    import moment from 'moment';

    export default {
        name: "Ultrasound",

        computed: {
            ...mapGetters(["ultrasound", "hasAdminRole", "hasMedecinControleRole", "hasPraticienRole","hasAssistante"]),

            can: function (){
                if (this.hasAdminRole){
                    return true;
                }else{
                    return  this.hasPraticienRole;
                }
            },

            mUltrasound: function() {
                return this.ultrasound;
            }
        },

        data() {
            return {
                ultrasound_id: this.$route.params.ultrasound
            }
        },

        methods: {
            getUltrasound() {
                let args = {
                    ultrasound: this.ultrasound_id
                };

                this.$store.dispatch("getUltrasound", { args });
            },

            formattedDate(date) {
                return moment(date).format('DD-MM-YYYY HH:mm');
            },

            updateUltrasound() {
                this.$router.push({ name: 'edit-ultrasound', params: { ultrasound: this.ultrasound_id } });
            },

            deleteUltrasound() {
                let self = this;
                let args = {
                    ultrasound: this.ultrasound_id
                };

                let successMessage = this.$i18n.t('message.ultrasoundDeleted');
                let errorMessages = {
                    generic: this.$i18n.t('message.genericError'),
                    error: this.$i18n.t('message.error')
                };

                this.$store.dispatch('deleteUltrasound', { args, index: self.ultrasound_id, successMessage, errorMessages }).then(() => {
                    self.$bvModal.hide('delete-modal');
                    this.$router.back();

                });
            }
        },

        mounted() {
            this.getUltrasound();
        }
    }
</script>

<style scoped>

</style>